import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Entrevista } from '../entrevistas/entrevista';
import { EntrevistaService } from '../entrevistas/entrevista.service';

@Component({
    selector: 'app-listar-entrevistas',
    templateUrl: './listar-entrevistas.component.html',
    providers: [
      EntrevistaService
    ]
})
export class ListarEntrevistasComponent implements OnInit {

	imgViewEntrevista = "../../assets/img/searchicon.png";

  imgEditEntrevista = "../../assets/img/pencilicon.png";

  incidente_id: number;

  entrevista: Entrevista;

  entrevistas: Entrevista[];

  getEntrevistas(): void {
    this.route.params.forEach((params: Params) => {
     let id = params['id']; // id do incidente

     this.incidente_id = id;

     if (id !== undefined) {
       this.entrevistaService.getEntrevistas(id)
         .then((entrevista) => this.entrevistas = entrevista);
     }

   });

  }

  constructor(private entrevistaService: EntrevistaService,
                private route: ActivatedRoute) {
      this.entrevista = new Entrevista();
  }
	ngOnInit() {
		this.getEntrevistas();
	}

};



// WEBPACK FOOTER //
// ./src/app/listar-entrevistas/listar-entrevistas.component.ts